<template>
    <div class="content contentPageList">
        <div class="catalog">
            <p>
                <span>目录</span>
                Catalog
            </p>
        </div>
        <div class="main" v-for="(value,index) in tData" :key="index">
            <p class="partTitle">{{value.title}}</p>
            <div class="small_title_box" key={idx} v-for="(val,idx) in value.sTitle" :key="idx">
                <div class="small_titled">{{val}}</div>
                <div class="line"></div>
                <div class="page_number"></div>
            </div>
        </div>
    </div>
</template>
<script>
import MiddleTitle from './middleTitle'
export default {
    props: [],
    name: 'pageList',
    components: {
        MiddleTitle
    },
    data() {
        return {
            tData:[
                {title: 'part.1基本信息', sTitle: ['学生普查','成绩记录','竞赛信息','综合素质']},
                // {title: 'part.2个人特质', sTitle: ['人格特性','智能水平','兴趣倾向','职业价值观','心理适应性']},
                {title: 'part.2我的目标', sTitle: ['目标规划','规划调整','目标拆分']},
                {title: 'part.3行动计划', sTitle: ['规划统计','学习习惯养成']},
                {title: 'part.4咨询记录', sTitle: ['咨询记录']},

            ]
        }
    },
    computed: {

    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>